import { h } from 'preact';

const ProductBadges = (props) => {
    // eslint-disable-next-line max-len
    const Badges = props.badges?.slice(0,2).map((badge,index)=><div key={index}>{index !==0 && '|'} {badge}</div>)
    return (
        <div className='md:absolute z-[8] inline-flex items-center left-5.5 top-3 gap-2 capitalize body-2'>{Badges}</div>
    )}

export default ProductBadges;